/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bannerControllerCreate } from '../fn/banner/banner-controller-create';
import { BannerControllerCreate$Params } from '../fn/banner/banner-controller-create';
import { bannerControllerDelete } from '../fn/banner/banner-controller-delete';
import { BannerControllerDelete$Params } from '../fn/banner/banner-controller-delete';
import { bannerControllerFindAll } from '../fn/banner/banner-controller-find-all';
import { BannerControllerFindAll$Params } from '../fn/banner/banner-controller-find-all';
import { bannerControllerFindAllShownBanners } from '../fn/banner/banner-controller-find-all-shown-banners';
import { BannerControllerFindAllShownBanners$Params } from '../fn/banner/banner-controller-find-all-shown-banners';
import { bannerControllerFindById } from '../fn/banner/banner-controller-find-by-id';
import { BannerControllerFindById$Params } from '../fn/banner/banner-controller-find-by-id';
import { bannerControllerReorder } from '../fn/banner/banner-controller-reorder';
import { BannerControllerReorder$Params } from '../fn/banner/banner-controller-reorder';
import { bannerControllerUpdate } from '../fn/banner/banner-controller-update';
import { BannerControllerUpdate$Params } from '../fn/banner/banner-controller-update';
import { BannerDto } from '../models/banner-dto';

@Injectable({ providedIn: 'root' })
export class BannerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bannerControllerFindAll()` */
  static readonly BannerControllerFindAllPath = '/api/banners';

  /**
   * 모든 Banner 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindAll$Response(params?: BannerControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
    return bannerControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Banner 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindAll(params?: BannerControllerFindAll$Params, context?: HttpContext): Observable<Array<BannerDto>> {
    return this.bannerControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BannerDto>>): Array<BannerDto> => r.body)
    );
  }

  /** Path part for operation `bannerControllerCreate()` */
  static readonly BannerControllerCreatePath = '/api/banners';

  /**
   * 새 배너 등록.
   *
   * 새로운 배너를 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerCreate$Response(params: BannerControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    return bannerControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 배너 등록.
   *
   * 새로운 배너를 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerCreate(params: BannerControllerCreate$Params, context?: HttpContext): Observable<BannerDto> {
    return this.bannerControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerFindAllShownBanners()` */
  static readonly BannerControllerFindAllShownBannersPath = '/api/banners/active';

  /**
   * 활성화된 배너 목록 조회.
   *
   * 활성화된 배너 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerFindAllShownBanners()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindAllShownBanners$Response(params?: BannerControllerFindAllShownBanners$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
    return bannerControllerFindAllShownBanners(this.http, this.rootUrl, params, context);
  }

  /**
   * 활성화된 배너 목록 조회.
   *
   * 활성화된 배너 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerFindAllShownBanners$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindAllShownBanners(params?: BannerControllerFindAllShownBanners$Params, context?: HttpContext): Observable<Array<BannerDto>> {
    return this.bannerControllerFindAllShownBanners$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BannerDto>>): Array<BannerDto> => r.body)
    );
  }

  /** Path part for operation `bannerControllerFindById()` */
  static readonly BannerControllerFindByIdPath = '/api/banners/{id}';

  /**
   * 배너 조회.
   *
   * 입력한 ID와 일치하는 배너를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindById$Response(params: BannerControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    return bannerControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 조회.
   *
   * 입력한 ID와 일치하는 배너를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindById(params: BannerControllerFindById$Params, context?: HttpContext): Observable<BannerDto> {
    return this.bannerControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerDelete()` */
  static readonly BannerControllerDeletePath = '/api/banners/{id}';

  /**
   * 배너 삭제.
   *
   * 배너를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerDelete$Response(params: BannerControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return bannerControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 삭제.
   *
   * 배너를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerDelete(params: BannerControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.bannerControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bannerControllerUpdate()` */
  static readonly BannerControllerUpdatePath = '/api/banners/{id}';

  /**
   * 배너 수정.
   *
   * 배너 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerUpdate$Response(params: BannerControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    return bannerControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 수정.
   *
   * 배너 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerUpdate(params: BannerControllerUpdate$Params, context?: HttpContext): Observable<BannerDto> {
    return this.bannerControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerReorder()` */
  static readonly BannerControllerReorderPath = '/api/banners/reorder';

  /**
   * 배너 순서 변경.
   *
   * 입력한 ID와 일치하는 배너의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerReorder$Response(params: BannerControllerReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return bannerControllerReorder(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 순서 변경.
   *
   * 입력한 ID와 일치하는 배너의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerReorder(params: BannerControllerReorder$Params, context?: HttpContext): Observable<void> {
    return this.bannerControllerReorder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
